var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NewsItem = exports.Date = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _Basic = require("../../../elements/Basic");

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/News/NewsList.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var _Date = function (_React$Component) {
  (0, _inherits2.default)(Date, _React$Component);

  var _super = _createSuper(Date);

  function Date() {
    (0, _classCallCheck2.default)(this, Date);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Date, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          publishingDate = _this$props.publishingDate,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["publishingDate"]);
      var currentDate = (0, _moment.default)();
      var published = (0, _moment.default)(publishingDate);
      var timeDiffMin = Math.abs(currentDate.diff(published, 'm'));
      var yesterday = (0, _moment.default)(currentDate).subtract(1, 'days').format('L');
      var publishingDay = (0, _moment.default)(published).format('L');

      if (timeDiffMin <= 59) {
        return _react.default.createElement(_Basic.Text, (0, _extends2.default)({
          size: "small"
        }, rest, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 17
          }
        }), (0, _i18n.default)('teaser_date_prefix') + " " + timeDiffMin + " " + (0, _i18n.default)('minute_short'));
      } else if (timeDiffMin >= 60 && publishingDay === yesterday) {
        return _react.default.createElement(_Basic.Text, (0, _extends2.default)({
          size: "small"
        }, rest, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 31,
            columnNumber: 20
          }
        }), "" + (0, _i18n.default)('last_day'));
      }

      return _react.default.createElement(_Basic.Text, (0, _extends2.default)({
        size: "small"
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 16
        }
      }), "" + publishingDay);
    }
  }]);
  return Date;
}(_react.default.Component);

exports.Date = _Date;

var NewsItem = function NewsItem(_ref) {
  var headline = _ref.headline,
      category = _ref.category,
      publishedAt = _ref.publishedAt,
      onPress = _ref.onPress,
      href = _ref.href;
  return _react.default.createElement(_Touchable.default, {
    onPress: onPress,
    href: href,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Column, {
    mb: 2,
    p: 2,
    borderX: 1,
    borderY: 1,
    borderColor: "border.main",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }, _react.default.createElement(_Basic.Row, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 13
    }
  }, _react.default.createElement(_Basic.SubHeading, {
    bold: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 17
    }
  }, headline)), _react.default.createElement(_Basic.Row, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 13
    }
  }, _react.default.createElement(_Basic.View, {
    flexing: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 17
    }
  }, _react.default.createElement(_Basic.Text, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 21
    }
  }, category)), _react.default.createElement(_Basic.View, {
    flexing: true,
    justifyContent: "flex-end",
    alignItems: "flex-end",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 17
    }
  }, _react.default.createElement(_Date, {
    publishingDate: publishedAt,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 21
    }
  })))));
};

exports.NewsItem = NewsItem;

var NewsList = function NewsList(_ref2) {
  var _ref2$headline = _ref2.headline,
      headline = _ref2$headline === void 0 ? (0, _i18n.default)('newsticker') : _ref2$headline,
      _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items,
      onItemPress = _ref2.onItemPress;
  return _react.default.createElement(_react.default.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Row, {
    isFlex: true,
    my: 2,
    center: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 9
    }
  }, _react.default.createElement(_Basic.Text, {
    size: "large",
    bold: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 13
    }
  }, headline)), items.length ? items.map(function (item) {
    return _react.default.createElement(NewsItem, (0, _extends2.default)({
      key: "newsItem_" + item.id,
      onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onItemPress, item)
    }, item, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 17
      }
    }));
  }) : _react.default.createElement(_Basic.Row, {
    center: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 13
    }
  }, _react.default.createElement(_Basic.Text, {
    bold: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 17
    }
  }, (0, _i18n.default)('no_news'))));
};

var _default = NewsList;
exports.default = _default;